import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { useNavigate } from "react-router-dom";
import { getDocs, collection, query, orderBy } from 'firebase/firestore/lite';
import { db } from '../../firebase';
import { getOrcidProfileUrl } from '../../utils/orcid';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    'max-height': '70%',
    'max-width': '80%',
    'overflow-y': 'auto'
  },
};

export const CardAlumno = (props) => {
    const navigate = useNavigate();
    const [researchLines, setResearchLines] = useState([]);
    const [subLines, setSubLines] = useState([]);

    // Cargar líneas de investigación desde Firebase para obtener las imágenes
    useEffect(() => {
        const fetchResearchLines = async () => {
            try {
                const q = query(collection(db, "research-lines"), orderBy('order'));
                const querySnapshot = await getDocs(q);
                const newData = querySnapshot.docs
                    .map((doc) => ({ ...doc.data(), id:doc.id }))
                    .filter(line => line.enabled !== false);
                setResearchLines(newData);
            } catch (error) {
                console.error('Error fetching research lines:', error);
                setResearchLines([]);
            }
        };
        fetchResearchLines();
    }, []);

    // Cargar sub-líneas desde Firebase
    useEffect(() => {
        const fetchSubLines = async () => {
            try {
                const q = query(collection(db, "sub-research-lines"), orderBy('orden'));
                const querySnapshot = await getDocs(q);
                const newData = querySnapshot.docs
                    .map((doc) => ({ ...doc.data(), id:doc.id }))
                    .filter(subLine => subLine.enabled !== false);
                setSubLines(newData);
            } catch (error) {
                console.error('Error fetching sub-lines:', error);
                setSubLines([]);
            }
        };
        fetchSubLines();
    }, []);

    const goToStudent = async (id) => {
        navigate('/student/'+id);
    };
    const [modalIsOpen, setIsOpen] = React.useState(false);

    const openModal = () => {
        setIsOpen(true);
    }

    const afterOpenModal = () => {
    }

    const closeModal = () => {
        setIsOpen(false);
    }

    // Proyecto principal (isMain) o el primero si no hay principal
    const getMainOrFirstProject = () => {
        const proyectos = props.student.proyecto;
        if (!proyectos || proyectos.length === 0) return "";
        const principal = proyectos.find(p => p.isMain === true);
        const selected = principal || proyectos[0];
        return selected?.proyecto || "";
    };

    // Obtener el icono de la línea de investigación del estudiante
    const getLineImage = () => {
        // Si no hay línea de investigación o no se han cargado las líneas, usar icono del estudiante como fallback temporal
        if (!props.student.linea_investigacion) {
            if (props.student.icon_inv) {
                try {
                    return require('../../assets/icons-lineas/' + props.student.icon_inv);
                } catch (e) {
                    return require('../../assets/not_found.jpg');
                }
            }
            return require('../../assets/not_found.jpg');
        }

        // Si aún no se han cargado las líneas, esperar y usar icono temporalmente
        if (!researchLines.length) {
            if (props.student.icon_inv) {
                try {
                    return require('../../assets/icons-lineas/' + props.student.icon_inv);
                } catch (e) {
                    return require('../../assets/not_found.jpg');
                }
            }
            return require('../../assets/not_found.jpg');
        }

        // Buscar la línea de investigación del estudiante
        // Primero intentar por ID (nuevo formato)
        let linea = researchLines.find(l => l.id === props.student.linea_investigacion);
        
        // Si no se encuentra por ID, intentar por nombre (compatibilidad con datos antiguos)
        if (!linea) {
            linea = researchLines.find(l => 
                l.name?.trim().toLowerCase() === props.student.linea_investigacion?.trim().toLowerCase()
            );
        }

        // Si se encuentra la línea, usar su icono (prioridad sobre imagen)
        if (linea) {
            // Primero intentar usar el icono de la línea
            if (linea.icon) {
                try {
                    return require('../../assets/icons-lineas/' + linea.icon);
                } catch (e) {
                    console.warn('Error cargando icono de línea:', linea.icon, e);
                }
            }
            
            // Si no hay icono pero hay imagen, usar la imagen como fallback
            if (linea.image) {
                // Si es una URL (Firebase Storage), usarla directamente
                if (linea.image.startsWith('http://') || linea.image.startsWith('https://')) {
                    return linea.image;
                }
                
                // Si es una ruta local, intentar cargar desde assets
                try {
                    if (linea.image.includes('infografias/')) {
                        return require(`../../assets/${linea.image}`);
                    } else if (linea.image.includes('colaboradores/')) {
                        return require(`../../assets/${linea.image}`);
                    } else {
                        return require(`../../assets/${linea.image}`);
                    }
                } catch (e) {
                    console.warn('Error cargando imagen local:', linea.image, e);
                }
            }
        }

        // Si no se encuentra la línea o no tiene icono/imagen, usar el icono del estudiante como fallback
        if (props.student.icon_inv) {
            try {
                return require('../../assets/icons-lineas/' + props.student.icon_inv);
            } catch (e) {
                return require('../../assets/not_found.jpg');
            }
        }
        
        return require('../../assets/not_found.jpg');
    }

    const orcidUrl = getOrcidProfileUrl(props.student.orcidid);

    return(
        <div>
            {
                props.isLineaCard
                ?
                    // Versión simplificada para líneas de investigación: foto a la izquierda, nombre y publicación a la derecha
                    <div className="card card-alumno-linea" onClick={openModal}>
                        <div className="row g-0 flex-grow-1">
                            <div className="col-md-4 d-flex align-items-center justify-content-center p-2">
                                <div className="img-container-linea">
                                    <img 
                                        id={'id-img-alumn' + props.idx} 
                                        loading="lazy" 
                                        className="img-alumno-linea" 
                                        src={ (props.student.url_imagen) ? props.student.url_imagen : ( !props.student.foto ?  require('../../assets/fotos/unknown.png') : require('../../assets/fotos/' + props.student.foto)) } 
                                        alt="Alumno" 
                                    />
                                </div>
                            </div>
                            <div className="col-md-8 d-flex flex-column justify-content-center p-3">
                                <h5 className="card-title name-alumno-linea mb-2">{props.student.name}</h5>
                                {getMainOrFirstProject() && (
                                    <p className="card-text publicacion-alumno-linea mb-0">{getMainOrFirstProject()}</p>
                                )}
                            </div>
                        </div>
                    </div>
                :
                ( !props.isHomeCard )
                ?
                    <div className="card card-alumno-modal" onClick={openModal}>
                        <div className="row h-100">
                            <div className="col-md-4 d-flex align-items-center justify-content-center">
                                <div className="img-container-modal m-2">
                                    <img className="img-card-modal" loading='lazy' src={ (props.student.url_imagen) ? props.student.url_imagen : ( !props.student.foto ?  require('../../assets/fotos/unknown.png') : require('../../assets/fotos/' + props.student.foto)) } alt="img"  /> 
                                </div>
                            </div>
                            <div className="col-md-8">
                                <h4 className="p-33">{props.student.name}</h4>
                                <p className="p-44">{ getMainOrFirstProject() }</p>
                            </div>
                        </div>
                    </div>
                :
                    <div className="card d-flex align-items-center justify-content-center card-alumno" style={{width: '18rem'}}>
                        <div className="img-card-container d-flex align-items-center justify-content-center" >
                            <div className="img-content">
                                <img id={'id-img-alumn' + props.idx} onClick={openModal} loading="lazy" className= "imagen-alumnos foto-alumno card-img-top-center" src={ (props.student.url_imagen) ? props.student.url_imagen : ( !props.student.foto ?  require('../../assets/fotos/unknown.png') : require('../../assets/fotos/' + props.student.foto)) } alt="Alumno" />
                            </div>
                            <div className="blob"></div> 
                        </div>
                        <div className="card-body bg-blue d-flex align-items-center justify-content-center flex-column">
                            <h5 className="card-title name-alumno text-center">{props.student.name} </h5>
                            <p className="card-text linea-alumno">{props.student.carrera}</p>
                            <a href={"#"+props.student.linea_investigacion} className="icono-linea-inv"><img src={getLineImage()} alt="Linea-icono" /></a>
                            <small className="card-text text-center linea-inv-text">
                                {(() => {
                                    // Primero intentar mostrar la sub-línea si existe
                                    if (props.student.sub_linea_investigacion && subLines.length > 0) {
                                        const subLinea = subLines.find(sl => sl.id === props.student.sub_linea_investigacion);
                                        if (subLinea && subLinea.titulo) {
                                            return subLinea.titulo;
                                        }
                                    }
                                    
                                    // Si no hay sub-línea, mostrar la línea de investigación
                                    const linea = researchLines.find(l => l.id === props.student.linea_investigacion);
                                    if (linea) {
                                        return linea.name;
                                    }
                                    // Fallback: mostrar el valor directamente (compatibilidad con datos antiguos)
                                    return props.student.linea_investigacion || 'Sin línea';
                                })()}
                            </small>
                        </div>
                    </div>
            }
            <Modal
                isOpen={modalIsOpen}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Practicante"
                >
                    <div class="modal-dialog">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h2>{props.student.name}</h2>
                            <button onClick={closeModal} type="button" class="btn close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            </div>
                            <div class="modal-body">
                                <h3>{props.student.carrera}</h3>
                                {orcidUrl && (
                                    <p className="mb-2">
                                        {/* eslint-disable-next-line react/jsx-no-target-blank */}
                                        <a target="_blank" rel="noreferrer" href={orcidUrl}>ORCID</a>
                                    </p>
                                )}
                                <div className="row">
                                    <div className="col">
                                        {
                                            ( props.student.proyecto.length >= 1 ) 
                                            ? 
                                                (<ul className="list-group">
                                                    {
                                                        props.projectTypes.map( (item, id) => {
                                                            let filterType = props.student.proyecto.filter( proyect => proyect.type === item.type && item.show_on_dialog );
                                                            if (!filterType.length) {
                                                                return (
                                                                    null
                                                                )
                                                            } else {
                                                                return (
                                                                    <li key={id} className="list-group-item">
                                                                        <h3>{ ( filterType.length > 1 ) ? item.title_multi : item.title }</h3>
                                                                        <ul className="list-group">
                                                                            {
                                                                                filterType.map( (proyect, idx) => {
                                                                                    if (proyect.url) {
                                                                                        // eslint-disable-next-line react/jsx-no-target-blank
                                                                                        return <li key={idx} className="list-group-item"><a target="_blank" rel="noreferrer" href={proyect.url}>{proyect.proyecto}</a></li>;
                                                                                    } else {
                                                                                        return <li key={idx} className="list-group-item">{proyect.proyecto}</li>;
                                                                                    }
                                                                                })
                                                                            }
                                                                        </ul>
                                                                    </li>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </ul>)
                                            :
                                                null
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button onClick={()=> goToStudent(props.student.id)} type="button" class="btn btn-secondary" data-dismiss="modal">Ver CVU</button>
                                <button onClick={closeModal} type="button" class="btn btn-danger" data-dismiss="modal">Cerrar</button>
                            </div>
                        </div>
                    </div>
            </Modal>
        </div>
    )
}

CardAlumno.propTypes = {
    student: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        url_imagen: PropTypes.string,
        foto: PropTypes.string,
        carrera: PropTypes.string,
        linea_investigacion: PropTypes.string,
        icon_inv: PropTypes.string,
        proyecto: PropTypes.arrayOf(PropTypes.shape({
            proyecto: PropTypes.string,
            url: PropTypes.string,
            type: PropTypes.string,
        })),
        orcidid: PropTypes.string,
    }).isRequired,
    idx: PropTypes.number,
    isHomeCard: PropTypes.bool,
    isLineaCard: PropTypes.bool,
    projectTypes: PropTypes.arrayOf(PropTypes.shape({
        type: PropTypes.string,
        title: PropTypes.string,
        title_multi: PropTypes.string,
        show_on_dialog: PropTypes.bool,
    })),
};

